// extracted by mini-css-extract-plugin
export default {"form":"docuForm_form__ZOdFw","line":"docuForm_line__nwfHl","input":"docuForm_input__a+7hF","area":"docuForm_area__7U8vk","button":"docuForm_button__9-aeN"};